import Navigation from './Navigation';
import ResumeSection from './ResumeSection';
import Footer from './Footer';
const Resume = () => {

  return (
    <div>
      <Navigation />
      <ResumeSection />
      <Footer />
    </div>
  )
}

export default Resume;